import { render, staticRenderFns } from "./editarAnuncio.vue?vue&type=template&id=9568a0a0&scoped=true"
import script from "./editarAnuncio.vue?vue&type=script&lang=js"
export * from "./editarAnuncio.vue?vue&type=script&lang=js"
import style0 from "./editarAnuncio.vue?vue&type=style&index=0&id=9568a0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9568a0a0",
  null
  
)

export default component.exports